
/* eslint-disable */
import Loading from 'vux/src/components/loading/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import api from '../api/api';

export default {
components: {
Loading,
Timeline,
TimelineItem,
Group,
Cell,
XButton
},
data() {
return {
order: {}
}
},
computed: {
orderProcessIndex() {
if(!this.order.purchaseOredr) {
switch (this.order.status) {
case 'auditing':
return 1;
case 'processing':
return 2;
case 'manufacturing':
return 3;
case 'warehousing':
return 4;
case 'delivering':
return 5;
case 'finished':
return 6;
}
return -1;
}
switch (this.order.status) {
case 'auditing':
return 1;
case 'purchasing':
return 2;
case 'receiving':
return 3;
case 'finished':
return 4;
}
return -1;
}
},
mounted() {
const orderNo = this.$route.params.orderNo;
if(orderNo) {
this.$vux.loading.show({
text: '加载中',
});
const $this = this;
api.getOrder(orderNo).then((resp) => {
$this.order = resp.data;
}).finally(() => {
$this.$vux.loading.hide();
});
}
},
methods: {
confirmDelivered() {
if(this.order.orderNo) {
this.$vux.loading.show({
text: '加载中',
});
const $this = this;
api.orderDelivered(this.order.orderNo).then((resp) => {
$this.order = resp.data;
}).finally(() => {
$this.$vux.loading.hide();
});
}
}
}
};




// WEBPACK FOOTER //
// ./src/components/OrderDetail.vue